export default "__VITE_ASSET__Cu217YbD__"